import { createSlice } from '@reduxjs/toolkit';
import { isBannedPoll, isEnableBanAllPoll } from './functions';
import { getConferenceState } from '../base/conference/functions';
import ReducerRegistry from '../base/redux/ReducerRegistry';
import { getParticipantById, isParticipantModerator } from '../base/participants/functions';
export const approveParticipantPoll = (id) => (dispatch, getState) => {
    const state = getState();
    const { conference } = getConferenceState(state);
    const participant = getParticipantById(state, id);
    if (!participant) {
        // Handle case where participant is undefined
        console.error(`Participant with ID ${id} not found.`);
        return;
    }
    const isBanned = isBannedPoll(participant, state);
    if (isBanned) {
        conference?.pollModerationApprove(id);
    }
};
export const rejectParticipantPoll = (id) => (dispatch, getState) => {
    const state = getState();
    const { conference } = getConferenceState(state);
    const participant = getParticipantById(state, id);
    if (!participant) {
        // Handle case where participant is undefined
        console.error(`Participant with ID ${id} not found.`);
        return;
    }
    const isBanned = isBannedPoll(participant, state);
    const isModerator = isParticipantModerator(participant);
    if (!isBanned && !isModerator) {
        conference?.pollModerationReject(id);
    }
};
export const enableBanAllPoll = () => (dispatch, getState) => {
    const state = getState();
    const { conference } = getConferenceState(state);
    const isBanAll = isEnableBanAllPoll(state);
    if (!isBanAll) {
        conference?.enablePollModeration();
    }
};
export const disableBanAllPoll = () => (dispatch, getState) => {
    const state = getState();
    const { conference } = getConferenceState(state);
    const isBanAll = isEnableBanAllPoll(state);
    if (isBanAll) {
        conference?.disablePollModeration();
    }
};
// Initial state
const initialState = {
    enabled: false,
    whitelist: {},
    blacklist: {},
    canPoll: undefined,
    actor: null,
    pollChanging: false,
};
// Create a slice for poll moderation
const pollModeration = createSlice({
    name: 'features/poll-moderation',
    initialState,
    reducers: {
        disablePollModeration: (state, action) => {
            if (state.enabled) {
                state.enabled = false;
                state.actor = action.payload;
                state.canPoll = undefined;
                state.whitelist = {};
                state.blacklist = {};
            }
        },
        enablePollModeration: (state, action) => {
            if (!state.enabled) {
                state.enabled = true;
                state.actor = action.payload;
                state.canPoll = undefined;
                state.whitelist = {};
                state.blacklist = {};
            }
        },
        localParticipantApproved: (state) => {
            state.canPoll = true;
        },
        localParticipantRejected: (state) => {
            state.canPoll = false;
        },
        participantApproved: (state, action) => {
            if (state.enabled) {
                state.whitelist = {
                    ...state.whitelist,
                    [action.payload.jid]: true
                };
            }
            else {
                state.blacklist = {
                    ...state.blacklist,
                    [action.payload.jid]: false
                };
            }
        },
        participantRejected: (state, action) => {
            if (state.enabled) {
                state.whitelist = {
                    ...state.whitelist,
                    [action.payload.jid]: false
                };
            }
            else {
                state.blacklist = {
                    ...state.blacklist,
                    [action.payload.jid]: true
                };
            }
        },
        hasChangePoll: (state, action) => {
            state.pollChanging = action.payload;
        }
    }
});
// Register reducer
ReducerRegistry.register('features/poll-moderation', pollModeration.reducer);
export const { disablePollModeration, enablePollModeration, localParticipantApproved, localParticipantRejected, participantApproved, participantRejected, hasChangePoll } = pollModeration.actions;
export default pollModeration.reducer;
